"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOutputWebClientMethod = exports.NoInputWebClientMethod = exports.DefaultWebClientMethod = void 0;
/**
 * An implementation of a WebClientMethod
 */
var DefaultWebClientMethod = /** @class */ (function () {
    function DefaultWebClientMethod(name) {
        this.name = name;
    }
    // public method: string;
    DefaultWebClientMethod.prototype.isValidInput = function (input) { return !!input; };
    DefaultWebClientMethod.prototype.isValidOutput = function (output) { return !!output; };
    return DefaultWebClientMethod;
}());
exports.DefaultWebClientMethod = DefaultWebClientMethod;
/**
 * An implementation of a WebClientMethod that requires no input
 */
var NoInputWebClientMethod = /** @class */ (function () {
    function NoInputWebClientMethod(name) {
        this.name = name;
    }
    // public method: string;
    NoInputWebClientMethod.prototype.isValidInput = function (input) { return !input; };
    NoInputWebClientMethod.prototype.isValidOutput = function (output) { return !!output; };
    return NoInputWebClientMethod;
}());
exports.NoInputWebClientMethod = NoInputWebClientMethod;
/**
 * An implementation of a WebClientMethod that requires no output
 */
var NoOutputWebClientMethod = /** @class */ (function () {
    function NoOutputWebClientMethod(name) {
        this.name = name;
    }
    // public method: string;
    NoOutputWebClientMethod.prototype.isValidInput = function (input) { return !!input; };
    NoOutputWebClientMethod.prototype.isValidOutput = function (output) { return !output; };
    return NoOutputWebClientMethod;
}());
exports.NoOutputWebClientMethod = NoOutputWebClientMethod;
//# sourceMappingURL=webClientMethod.js.map